import Component from '../../classes/Component';
import { $dom } from '../../helpers/dom';
import { $events } from '../../helpers/events';
import variables from '../../variables';

const { get, getAll, addClass, removeClass, hasClass } = $dom

export default function calculatorFunctional(rootId = 'js-calculator-main') {

  const tippyButtonSelector = '.js-tippy-button';

  const tippyButtonHandler = event => {

    const target = event.target.closest(tippyButtonSelector)

    removeClass(getAll(tippyButtonSelector), variables.classNames.active)

    if (!target && hasClass(get(tippyButtonSelector), variables.classNames.active)) return

    addClass(target, variables.classNames.active);

  }

  const tippyButtonHide = () => {

    removeClass(getAll(tippyButtonSelector), variables.classNames.active)
  }

  const outsideClickHandler = event => !event.target.closest(tippyButtonSelector) ? tippyButtonHide() : null;

  return new Component({
    name: 'calculatorFunctional',
    requiredSelector: `#${rootId}`,
    rootElementId: rootId,
    onCreate() { },
    onInit() {

      $events.delegate
        .on('click tap', tippyButtonSelector, tippyButtonHandler)
        .on('click tap', window, outsideClickHandler)
    },
    onDestroy() {
      $events.delegate
        .off('click tap', tippyButtonSelector, tippyButtonHandler)
        .off('click tap', window, outsideClickHandler)
    }
  })
}